import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {ThuService} from '../../../../service/email/service-thu';
import {DocumentDraftService} from '../../../../service/draft/service-documentdraft';
import {DocumentDraftFileService} from '../../../../service/draft/service-documentdraftfile';
import {DocumentDraft} from '../../../../models/draft/documentdraft';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {EditThuComponent} from '../soanthu/edit.component';
import {CommandUtil} from '../../../../global/commandutil';
import {TraLoiSoanThaoThuComponent} from '../soanthu/traloisoanthao.component';
@Component({
  templateUrl: './thudangsoan.component.html',

})
export class ThuDangSoanComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: DocumentDraft[];
  public srChuDe: string = '';
  public nguoiTao: number = Sessioncommand.staffId;
  constructor(
    public thuService: ThuService,
    public documentDraftService: DocumentDraftService,
    public documentDraftFileService: DocumentDraftFileService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public commandUtil: CommandUtil

  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.search();
  }

  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }

  public edit(id: number, replyId: number) {
    if(replyId === 0) {
      const modalEdit = this.bsModalService.show(EditThuComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<EditThuComponent>modalEdit.content).edit(
        id
      );
      (<EditThuComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true)
          this.search();

      });
    }
    else
    {
      const modalEdit = this.bsModalService.show(TraLoiSoanThaoThuComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<TraLoiSoanThaoThuComponent>modalEdit.content).edit(
        id
      );
      (<TraLoiSoanThaoThuComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true)
          this.search();

      });
    }

  }
  search()
  {
    this.documentDraftService.findAllByPaging(this.srChuDe, 'EMAIL', this.nguoiTao, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.documentDraftService.getCountByKeyword(this.srChuDe,'EMAIL', this.nguoiTao).subscribe(recordCount => this.totalItems = recordCount);
  }

  deleteItem(id: number)
  {
    this.documentDraftService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();
        Sessioncommand.emailStatus = 0;

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

